
import { defineComponent } from 'vue';
import { useList } from '@/hooks/use-list';
import { getAppInfoPage } from '@/api/manage-app/app-manage';
import type {
  IAppInfoParams,
  IAppInfoItem,
} from '@/api/manage-app/app-manage/index.d';
import CreatedApp from './components/created-app.vue';
import DisabledApp from './components/disabled-app.vue';
import AppLog from './components/app-log.vue';
import { _CreatedApp } from './composables/useAppInfo';
import {
  ENABLED_STATUS_ENUM,
  ENABLED_STATUS_LIST,
  UPDATE_DIMENSION_LIST,
  USER_SYSTEM_LIST,
  ADAPTATION_SYSTEM_LIST,
} from '@/constant';
import { getLabelByVal } from '@/core/utils/index';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  name: 'AppManage',
  components: {
    CreatedApp,
    DisabledApp,
    AppLog,
  },
  setup() {
    const {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IAppInfoItem, IAppInfoParams>({
      request: {
        api: getAppInfoPage,
        params: {
          appName: '',
          pageNum: 1,
          pageSize: 10,
        },
      },
      response: {
        handleResponseData(list) {
          list.forEach((item) => {
            item.adaptiveSystemList = item.adaptiveSystem.split(',')
              .filter(adaptiveSystem => adaptiveSystem)
              .map(adaptiveSystem => getLabelByVal(ADAPTATION_SYSTEM_LIST, adaptiveSystem))
              .join('、');
          });
          return list;
        },
      },
    });
    handleSearch();
    const {
      handleCreated,
      createdAppVisible,
      disabledVisible,
      handleDisabled,
      handleDel,
      handleShowLogs,
      logVisible,
      handelAppEdit,
      accountAppItem,
      handleEnable,
      gridData,
    } = _CreatedApp();

    const permissionConfig = usePermissionConfig();

    return {
      params,
      tableData,
      tableTotal,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      handleCreated,
      createdAppVisible,
      disabledVisible,
      handleDisabled,
      handleDel,
      handleShowLogs,
      logVisible,
      handleEnable,
      handelAppEdit,
      accountAppItem,
      gridData,
      permissionConfig,
      ENABLED_STATUS_ENUM,
      ENABLED_STATUS_LIST,
      USER_SYSTEM_LIST,
      UPDATE_DIMENSION_LIST,
    };
  },
});
